export var item = '_1J1Ih';
export var shine = '_2_wNU';
export var card = '_3MjJ9';